import {
  FormEditor as FormEditorStable,
  DefaultEditorRegistry as DefaultEditorRegistryStable,
  DefaultElementConfigRegistry as DefaultElementConfigRegistryStable,
  DefaultToolbarItemList as DefaultToolbarItemListStable,
} from "@graffer-inc/form-builder";

export const FormEditor: typeof FormEditorStable = (props) => {
  return <FormEditorStable {...props} />;
};

export const DefaultEditorRegistry = DefaultEditorRegistryStable;

export const DefaultElementConfigRegistry = DefaultElementConfigRegistryStable;

export const DefaultToolbarItemList = DefaultToolbarItemListStable;
